import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { richTextToHTML } from "src/clients/uniform-client/enhancers/utils";

import { templateDescriptionContentfulRelayFragment$key } from "@/__generated_contentful__/templateDescriptionContentfulRelayFragment.graphql";
import { SanitizedRichText } from "@/components/confluence/util/sanitized-rich-text";

interface TemplateDescriptionProps {
    template: templateDescriptionContentfulRelayFragment$key;
}

const TemplateDescriptionRelayFragment = graphql`
    fragment templateDescriptionContentfulRelayFragment on ProductTemplate {
        aboutThisTemplate {
            json
        }
    }
`;

export const TemplateDescription = ({ template }: TemplateDescriptionProps) => {
    const { aboutThisTemplate } = useFragment(
        TemplateDescriptionRelayFragment,
        template
    );

    if (!aboutThisTemplate) {
        return null;
    }

    const aboutThisTemplateString = aboutThisTemplate?.json
        ? richTextToHTML(aboutThisTemplate.json)
        : "";

    return (
        <section data-testid="confluence-template-details-template-description">
            <SanitizedRichText innerHTML={aboutThisTemplateString} />
        </section>
    );
};
